import {
    IGenericBet,
    ISingleBet,
    ISubscriptionBet,
    ICombinationBet,
} from '@bg-shared/business/Reports/interfaces_legacy/Bets';
import { EnumBetType } from '@bg-shared/enums/BetType';

export const getBetType = {
    isSingle: (bet: IGenericBet): bet is ISingleBet =>
        (bet as ISingleBet).type === EnumBetType.SINGLE,

    isSubscription: (bet: IGenericBet): bet is ISubscriptionBet =>
        (bet as ISubscriptionBet).type === EnumBetType.SUBSCRIPTION,

    isCombination: (bet: IGenericBet): bet is ICombinationBet =>
        (bet as ICombinationBet).type === EnumBetType.COMBINATION,
};
